import { FC } from "react";
import { Navigate } from "react-router-dom";
import { PREMIUM_VOICE_LIBRARY_FULL_PATH } from "../../utils/menuPathNormalize";

/** 旧平铺路由 `/voice-library` → 工作台嵌套页，保留书签与菜单 component 映射兼容 */
export const VoiceLibraryEntryRedirect: FC = () => (
  <Navigate to={PREMIUM_VOICE_LIBRARY_FULL_PATH} replace />
);
